import defaultApi from './defaultApi';
import store from '@/store';

const k8S_LIST = ['Kubernetes', 'DataWrangler', 'QuickQuery'];

const productApi = {
  product: {
    prefix:
      process.env.VUE_APP_PROXY + process.env.VUE_APP_PUBLIC_PATH + '/cloudmonitorings/product',
    SWAGGER: '/v2/api-docs?group=com.sds.scpm',
    API_INFO: {},
    SAMPLE: {},
    getProductSubTypes(logMetricYn, conditionType = '', useYn = 'Y') {
      // if (logMetricYn == 'Y') {
      //     if (store.state.productSubTypesY != null && store.state.productSubTypesY.length > 0) {
      //         // console.log('productSubTypesY exist return ', store.state.productSubTypesY);
      //         return Promise.resolve(store.state.productSubTypesY);
      //     }
      // } else if (logMetricYn == 'N') {
      //     if (store.state.productSubTypesN != null && store.state.productSubTypesN.length > 0) {
      //         // console.log('productSubTypesN exist return ', store.state.productSubTypesN);
      //         return Promise.resolve(store.state.productSubTypesN);
      //     }
      // }

      return new Promise((resolve) => {
        let param = {};
        param['logMetricYn'] = logMetricYn;
        param['conditionType'] = conditionType;
        param['useYn'] = useYn;
        // console.log('this = ', this);
        this.get('/v1/console/product-sub-types', param).then((data) => {
          if (Object.keys(data).length > 0) {
            data.sort((a, b) => {
              return a.typeOrder - b.typeOrder;
            });
            let _codes = [];
            for (let i = 0; i < data.length; i++) {
              let _row = data[i];
              _codes.push({ text: _row.productTypeName, value: _row.productTypeCode, ..._row });
            }
            if (logMetricYn == 'Y') {
              store.commit('setProductSubTypesY', _codes);
            } else if (logMetricYn == 'N') {
              store.commit('setProductSubTypesN', _codes);
            }
            resolve(_codes);
          }
        });
      });
    },
    getProductTypeList() {
      return new Promise((resolve) => {
        this.get('/v1/console/product-sub-types', {
          conditionType: '',
          useYn: 'Y'
        })
          .then((res) => {
            let data = [];
            if (res && res.length) {
              data = res.map((item) => {
                return {
                  ...item,
                  text: item.productTypeName,
                  key: item.productTypeCode
                };
              });
            }
            resolve(data);
          })
          .catch((error) => reject(error));
      });
    },
    getListProductObjectTypes(productTypeCode) {
      return new Promise((resolve, reject) => {
        this.get(`/v1/console/object-types`, null, true, false, {
          headers: { 'X-ResourceType': productTypeCode }
        })
          .then((data) => {
            let objectTypeList = [];
            if (data.contents.length > 0) {
              let dataContent = data.contents;
              for (let i = 0; i < dataContent.length; i++) {
                objectTypeList.push({
                  text: dataContent[i].objectTypeNameEng,
                  value: dataContent[i].objectType
                });
              }
            }
            resolve(objectTypeList);
          })
          .catch((err) => reject(err));
      });
    },
    getProductList(params, productTypeCode) {
      return new Promise((resolve, reject) => {
        this.post('/v1/console/products', params, true, false, {
          headers: { 'X-ResourceType': productTypeCode }
        })
          .then((data) => {
            if (Object.keys(data).length > 0) {
              resolve(data);
            }
          })
          .catch((err) => reject(err));
      });
    },

    // 검색필터 조회
    // conditionType : log, metric, metricAgentManage, logAgentManage, eventSetting
    getProductConditions(
      productTypeCode,
      conditionType = 'metric',
      productSq = null,
      handledAuthError = false
    ) {
      return new Promise((resolve) => {
        let param = {
          conditionType: conditionType,
          productSq: productSq
        };
        this.get(
          `/v1/console/products/conditions?`,
          param,
          true,
          false,
          {
            headers: { 'X-ResourceType': productTypeCode }
          },
          false,
          [],
          { handledAuthError }
        ).then((data) => {
          if (Object.keys(data).length > 0) {
            if (conditionType === 'eventSetting') {
              resolve(data);
            } else {
              let returnList = {};
              data.returnList.map((colId) => {
                returnList[colId] = true;
              });
              data.returnList = returnList;

              resolve(data);
            }
          }
        });
      });
    },
    getProductMetric(params, productTypeCode, handledAuthError = false) {
      return new Promise((resolve, reject) => {
        this.post(
          '/v1/console/metrics',
          params,
          true,
          false,
          {
            headers: { 'X-ResourceType': productTypeCode }
          },
          false,
          [],
          { handledAuthError }
        )
          .then((data) => {
            if (Object.keys(data).length > 0) {
              return resolve(data.contents);
            }
          })
          .catch((err) => reject(err));
      });
    },
    getProductMetricData(params, productTypeCode, loadingBar = true, handledAuthError = false) {
      this.beforeCallMetricData(params);

      return new Promise((resolve, reject) => {
        this.post(
          '/v1/console/metric-data',
          params,
          loadingBar,
          false,
          {
            headers: { 'X-ResourceType': productTypeCode }
          },
          false,
          [],
          { handledAuthError }
        )
          .then((data) => {
            if (Object.keys(data).length > 0) {
              return resolve(data.contents);
            }
          })
          .catch((err) => reject(err));
      });
    },
    beforeCallMetricData(params) {
      const {metricDataConditionConsole} = params;

      /**
       * Fix duplicated objectNames
       * combining objectName and productResourceId to differentiate individual item on getProductObjects function of productApi.js
       * remove productResourceId from objectName to call api /metric-data on getProductMetricData function of productApi.js
       * The same case on getObjectDatas function of CustomCommonConfig.vue
       */
      if (metricDataConditionConsole.metricKey === 'system.filesystem.used.pct') {
        const { productResourceInfosConsole } = metricDataConditionConsole;
        const resourceInfos = productResourceInfosConsole.map(item => {
          const newObjectList = item.objectList.map(object => {
            if(object.indexOf("####") > 0){
              return object.substr(0, object.indexOf("####"))
            }
            return object;
          })
          return {
            ...item,
            objectList: [...newObjectList]
          }
        });
        params.metricDataConditionConsole.productResourceInfosConsole = resourceInfos;
      }
    },
    getProductObjects(params, productTypeCode, handledAuthError = false) {
      return new Promise((resolve, reject) => {
        this.post(
          '/v1/console/objects',
          params,
          true,
          false,
          {
            headers: { 'X-ResourceType': productTypeCode }
          },
          false,
          [],
          { handledAuthError }
        )
          .then((data) => {
            const isFileSystem = params.metricKeyList.includes('system.filesystem.used.pct');
            return resolve(this.afterCallObjects(data, isFileSystem));
          })
          .catch((err) => reject(err));
      });
    },
    /**
     * Fix duplicated objectNames
     * combining objectName and productResourceId to differentiate individual item on getProductObjects function of productApi.js
     * remove productResourceId from objectName to call api /metric-data on getProductMetricData function of productApi.js
     * The same case on getObjectDatas function of CustomCommonConfig.vue
     */
    afterCallObjects(data, isFileSystem = false) {
      if (!isFileSystem) return data;
      
      return data.map(item => ({
        ...item,
        objectName: item.objectName + "####" + item.objectDisplayName
      }));
    },
    getSummaries(params, productTypeCode, handledAuthError = false) {
      return new Promise((resolve, reject) => {
        this.get(
          '/v1/console/products/summaries',
          params,
          true,
          false,
          {
            headers: { 'X-ResourceType': productTypeCode }
          },
          false,
          [],
          { handledAuthError }
        )
          .then((data) => {
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    },
    getObjectTypeList(params, productTypeCode, needHandleAuthorizationCheck = false) {
      let api = '/v1/console/objects/lb';
      if (k8S_LIST.includes(productTypeCode)) {
        api = '/v1/console/objects/k8s';
      } else if (productTypeCode === 'DataFlow' || productTypeCode === 'DataOps') {
        api = '/v1/console/objects/dataops-dataflow';
      }
      return new Promise((resolve, reject) => {
        this.post(
          api,
          params,
          true,
          false,
          { headers: { 'X-ResourceType': productTypeCode } },
          needHandleAuthorizationCheck
        )
          .then((data) => {
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    },
    getProduct(params, loadingBar = false, needHandleAuthorizationCheck = false) {
      return new Promise((resolve, reject) => {
        this.get(
          `/v1/console/products/${params.productSq}`,
          {},
          loadingBar,
          false,
          { headers: { 'X-ResourceType': params.productTypeCode } },
          needHandleAuthorizationCheck
        )
          .then((data) => {
            return resolve(data);
          })
          .catch((error) => reject(error));
      });
    },
    getProductDetail(
      params,
      productTypeCode,
      needHandleAuthorizationCheck = false,
      loading = true,
      handledAuthError = false
    ) {
      return new Promise((resolve, reject) => {
        this.get(
          `/v1/console/products/${params.productId}`,
          {},
          loading,
          false,
          { headers: { 'X-ResourceType': productTypeCode } },
          needHandleAuthorizationCheck,
          [],
          { handledAuthError }
        )
          .then((data) => {
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    },

    getTargetProductList(params, productTypeCode, handledAuthError = false) {
      return new Promise((resolve, reject) => {
        this.get(
          '/v1/console/products',
          params,
          true,
          false,
          {
            headers: { 'X-ResourceType': productTypeCode }
          },
          false,
          [],
          { handledAuthError }
        )
          .then((data) => {
            if (Object.keys(data).length > 0) {
              resolve(data);
            }
          })
          .catch((err) => reject(err));
      });
    },

    // parmas : {productResourceId: productResourceId, actionName: 'MonitorView/MonitorSet'} - 사용안함 22.11.24
    // parmas : {productResourceIds: [productResourceId], actionName: 'MonitorView/MonitorSet'}
    checkProductAuthorization(params, productTypeCode, handledAuthError = false) {
      if (Object.keys(params).includes('productResourceId')) {
        params['productResourceIds'] = params.productResourceId;
        if (typeof params.productResourceId == 'string') {
          params['productResourceIds'] = [params.productResourceId];
        }
        delete params.productResourceId;
      }
      return new Promise((resolve, reject) => {
        this.post(
          '/v1/console/products/check-authorization',
          params,
          true,
          false,
          {
            headers: { 'X-ResourceType': productTypeCode }
          },
          false,
          [],
          { handledAuthError }
        )
          .then((data) => {
            if (Object.keys(data).length > 0) {
              if (data.authorizationCheckResult == 'Allow') resolve(true);
              else
                reject({
                  code: 'AccessDenied',
                  params: [
                    {
                      name: 'service',
                      value: data.serviceName
                    },
                    {
                      name: 'action',
                      value: data.actionName
                    }
                  ]
                });
            }
          })
          .catch((error) => reject(error));
      });
    },
    // 상품유형별 권한체크
    checkProductSubTypeAuthorization(productTypeCode) {
      return new Promise((resolve, reject) => {
        this.get('/v1/console/product-sub-types/check-authorization', {}, true, false, {
          headers: { 'X-ResourceType': productTypeCode }
        })
          .then((data) => {
            resolve(data);
          })
          .catch((error) => reject(error));
      });
    },

    /**
     * Function call API download raw metric data
     * @params
     * */
    downloadRawMetricData(params, productTypeCode, loadingBar = true) {
      this.beforeCallMetricData(params);
      
      return new Promise((resolve, reject) => {
        this.post('/v1/console/metric-data', params, loadingBar, false, {
          headers: { 'X-ResourceType': productTypeCode }
        })
          .then((data) => {
            if (Object.keys(data).length > 0) {
              return resolve(data.contents);
            }
          })
          .catch((err) => reject(err));
      });
    },

    getTargetProductEvent({ projectIdList = [], productTypeCodeList = [] }) {
      return new Promise((resolve, reject) => {
        this.post(
          '/v1/console/products/all-project',
          {
            projectIdList,
            productTypeCodeList
          },
          true,
          false
        )
          .then((data) => {
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    },

    getProductTypeMonitoringStatus() {
      return new Promise((resolve, reject) => {
        this.get('/v1/console/product-sub-types/top', {})
          .then((data) => {
            return resolve(data || []);
          })
          .catch((error) => reject(error));
      });
    },

    async getCollectionInterval(productTypeCode) {
      try {
        const collectionInterval = await this.get('/v1/console/products/period', {}, true, true, {
          headers: { 'X-ResourceType': productTypeCode }
        });
        if (typeof collectionInterval === 'string' && collectionInterval) return collectionInterval;
        return '1m';
      } catch (e) {
        return '1m';
      }
    }
  }
};
productApi.log = Object.assign(productApi.product, defaultApi);
export default productApi;
